import { render } from "./PvpSidebar.vue?vue&type=template&id=5b9ab54a&scoped=true"
import script from "./PvpSidebar.vue?vue&type=script&lang=ts"
export * from "./PvpSidebar.vue?vue&type=script&lang=ts"

import "./PvpSidebar.vue?vue&type=style&index=0&id=5b9ab54a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5b9ab54a"

export default script